import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountInitialize } from "store/accountActions";

import Footer from "components/Footers";
import PublicNavbar from "components/PublicNavbar";
import PopUpTerm from "components/PopUpTerm";
import routes, { renderRoutes } from "routes";
import CookieConsent from "components/CookieConsent";

import "assets/css/public.css";
import "assets/css/cookie-consent.css";

const withLayoutPrefix = (routesList, prefix) =>
  routesList.map((r) => ({
    ...r,
    layout: prefix,
  }));

const PublicLayout = (props) => {
  const prefix = props.match?.path || "/:lang";
  const urlLang = props.match?.params?.lang;

  const dispatch = useDispatch();
  const { languages } = useSelector((state) => state.staticData);
  const account = useSelector((state) => state.account);

  useEffect(() => {
    if (!urlLang || !languages?.length) return;

    const normalize = (code) => code.split("-")[0].toLowerCase();

    const langFromUrl = languages.find(
      (l) => normalize(l.code) === urlLang.toLowerCase()
    );

    if (langFromUrl && account?.language?.code !== langFromUrl.code) {
      dispatch(accountInitialize({ language: langFromUrl }));
    }
  }, [urlLang, languages]);

  return (
    <>
      <PublicNavbar />
      <div className="filter" />
      {renderRoutes(withLayoutPrefix(routes, prefix))}
      <Footer fluid />
      <CookieConsent />
      <PopUpTerm />
    </>
  );
};

export default PublicLayout;
